import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const tl = (n) => (Number(n) || 0).toLocaleString("tr-TR", { maximumFractionDigits: 2 });
const esc = (s) => String(s ?? "").replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));

export async function quotePdf({ brand, musteri, q, wa, notes }) {
  const lines = String(notes || "").split("\n").map((x) => x.trim()).filter(Boolean);
  const logo = brand?.logo_url ? `${process.env.REACT_APP_BACKEND_URL}${brand.logo_url}` : "";
  const no = "TKF-" + Date.now().toString().slice(-8);
  const el = document.createElement("div");
  el.style.cssText = "position:fixed;left:-10000px;top:0;width:794px;background:#fff;color:#0f172a;font-family:Arial,Helvetica,sans-serif;padding:48px;box-sizing:border-box";
  el.innerHTML = `
    <div style="display:flex;justify-content:space-between;align-items:center;border-bottom:4px solid #2563eb;padding-bottom:16px">
      <div>${logo ? `<img crossorigin="anonymous" src="${logo}" style="height:64px;max-width:260px;object-fit:contain"/>` : ""}<div style="font-size:22px;font-weight:800;margin-top:6px">${esc(brand?.name)}</div></div>
      <div style="text-align:right"><div style="font-size:26px;font-weight:800;color:#2563eb">FİYAT TEKLİFİ</div><div style="font-size:12px;color:#475569">NO: ${no}<br/>TARİH: ${new Date().toLocaleDateString("tr-TR")}</div></div>
    </div>
    <div style="margin-top:24px;font-size:14px"><b>SAYIN:</b> ${esc(musteri || "MÜŞTERİMİZ")}</div>
    <table style="width:100%;margin-top:18px;border-collapse:collapse;font-size:14px">
      <thead><tr style="background:#2563eb;color:#fff">${["GÖNDERİLECEK İL", "KARGO TÜRÜ", "ADET", "DESİ", "KG", "FİYAT"].map((h) => `<th style="padding:10px;text-align:left">${h}</th>`).join("")}</tr></thead>
      <tbody><tr style="background:#f1f5f9">${[q.il, q.kargo_turu, q.adet, q.desi || "-", q.kg || "-"].map((v) => `<td style="padding:10px">${esc(v)}</td>`).join("")}<td style="padding:10px;font-weight:800;font-size:18px;color:#1d4ed8">${q.fiyat != null ? tl(q.fiyat) : "-"}</td></tr></tbody>
    </table>
    ${lines.length ? `<div style="margin-top:24px;font-size:12px;color:#475569;line-height:1.6">${lines.map((l) => "• " + esc(l)).join("<br/>")}</div>` : ""}
    <div style="margin-top:40px;border-top:1px solid #cbd5e1;padding-top:12px;font-size:12px;color:#475569">${esc(brand?.name)}${wa ? ` · WHATSAPP: +${esc(wa)}` : ""}</div>`;
  document.body.appendChild(el);
  try {
    await Promise.all([...el.querySelectorAll("img")].map((i) => (i.complete ? null : new Promise((r) => { i.onload = r; i.onerror = r; }))));
    const c = await html2canvas(el, { scale: 2, useCORS: true, backgroundColor: "#fff" });
    const pdf = new jsPDF({ unit: "pt", format: "a4" });
    const w = pdf.internal.pageSize.getWidth();
    pdf.addImage(c.toDataURL("image/jpeg", 0.92), "JPEG", 0, 0, w, (c.height * w) / c.width);
    pdf.save(`${no}_${q.il}.pdf`);
  } finally {
    el.remove();
  }
}
